import { render, staticRenderFns } from "./ClassStudentDetails.vue?vue&type=template&id=436fca18&"
import script from "./ClassStudentDetails.vue?vue&type=script&lang=js&"
export * from "./ClassStudentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClassStudentDetails.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports